import React from 'react';
import styles from './page1.scss';
import pic1 from './1.png';
import pic2 from './2.png';
import pic3 from './3.png';
import pic4 from './4.png';

function Page1(props) {
  return (
    <div className={styles['page1']} ref={props.myRef}>
      <div className={styles['page1-main']}>
        <div className={styles['page1-title']}>THE TEAM</div>

        <div className={styles['page1-subTitle']}>我们的团队</div>

        <div className={styles['page1-cardList']}>
          <div className={styles['page1-card']}>
            <div className={styles['page1-card-pic']}>
              <img src={pic1} />
            </div>

            <div className={styles['page1-card-name']}>
              <div className={styles.text}>李冰</div>
              <div className={styles.area} />
            </div>

            <div className={styles['page1-card-desc']}>
              WOW-TREND热点趋势 CEO/首席创意官
              国内资深的趋势专家、品牌顾问和权威讲师
            </div>

            <div className={styles['page1-card-line']}></div>

            <div className={styles['page1-card-row']} style={{ width: '200%' }}>
              毕业于北京服装学院<br />
              Première Vision Paris面料展时尚趋势版块研究成员<br />
              唯品大学、香港时尚买手学院特邀趋势导师<br />
              浙江大学、中国美术学院纺织服装研究院客座教授<br />
              时尚经纬欧洲趋势讲师
            </div>
          </div>

          <div className={styles['page1-card']}>
            <div className={styles['page1-card-pic']}>
              <img src={pic2} />
            </div>

            <div className={styles['page1-card-name']}>
              <div className={styles.text}>MIO GERALLO</div>
              <div className={styles.area} />
            </div>

            <div className={styles['page1-card-desc']}>
              设计顾问
            </div>

            <div className={styles['page1-card-line']}></div>

            <div className={styles['page1-card-row']}>
              8年中国市场经验<br />
              曾担任：<br />
              Promostly男女装总设计师<br />
              Prada女装版师<br />
              Kenzo产品开发负责人<br />
              Givenchy产品开发负责人<br />
            </div>
          </div>

          <div className={styles['page1-card']}>
            <div className={styles['page1-card-pic']}>
              <img src={pic3} />
            </div>

            <div className={styles['page1-card-name']}>
              <div className={styles.text}>CLAUDE VUILLEMET</div>
              <div className={styles.area} />
            </div>

            <div className={styles['page1-card-desc']}>
              趋势顾问
            </div>

            <div className={styles['page1-card-line']}></div>

            <div className={styles['page1-card-row']}>
              1985年成立个人趋势预测和品牌设计咨询公司<br />
              法国潮流资讯总咨询部门成员<br />
              法国颜色总趋势部门（CFC）成员
            </div>
          </div>

          <div className={styles['page1-card']}>
            <div className={styles['page1-card-pic']}>
              <img src={pic4} />
            </div>

            <div className={styles['page1-card-name']}>
              <div className={styles.text}>SABINE</div>
              <div className={styles.area} />
            </div>

            <div className={styles['page1-card-desc']}>
              趋势顾问
            </div>

            <div className={styles['page1-card-line']}></div>

            <div className={styles['page1-card-row']}>
              十三年Première Vision Paris面料展<br />
              时尚趋势负责人<br />
              十六年Peclers Paris趋势研究专家<br />
              十年品牌创意及时尚设计顾问<br />
              现任巴黎IFM顶级设计管理院校特邀讲师
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;